/*
 * Copyright (c) 2022-2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {Component, Input} from '@angular/core';
import {User} from '../../shared/model/user';
import {UserService} from '../../shared/user.service';
import {NavItem} from '../header/nav-item';

@Component({
    selector: 'cpl-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.less'],
    standalone: false
})
export class HomeComponent {
  @Input() navItems: NavItem [];

  hideData = true;
  loggedInUser: User;

    constructor(private userService: UserService) {

    }

    ngOnInIt(): void {
        this.loggedInUser = this.userService.user;
    }
}
